<div mat-dialog-title class="mat-dialog-title">
  <h3  class="nsc-title" id="{{data.id}}Title">{{ data.title }}</h3>
  <button mat-dialog-close class="close" aria-label="Close">
    <mat-icon class="nsc-icon__svg" svgIcon="close"></mat-icon>
  </button>
</div>
<mat-dialog-content class="mat-typography">
  <div id="{{data.id}}Content">
    <p aria-hidden="true"> {{ content.message }}</p>
    <span [attr.aria-label]="content.convertedTimeMessage"></span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="start">
  <button mat-raised-button class="nsc-button" color="primary" type="button" (click)="resetCountdown()">OK</button>
</mat-dialog-actions>